import React from 'react';

const SmartTable = ({ smartTableData }) => {
  const headers = smartTableData.length > 0 ? Object.keys(smartTableData[0]) : [];

  return (
    <div
      className="smart-table-container"
      style={{
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid white',
      }}
    >
      <table
        style={{
          width: '100%',
          borderSpacing: '0',
          borderCollapse: 'collapse',
        }}
      >
        <thead>
          <tr style={{ backgroundColor: 'lightgrey', color: 'black' }}>
            {headers.map((header, index) => (
              <th
                key={index}
                style={{
                  fontSize: '12px',
                  padding: '12px',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  color: 'black',
                  backgroundColor: 'lightgrey',
                  borderRight:
                    index !== headers.length - 1 ? '1px solid white' : 'none', // No right border for the last column
                  borderBottom: '1px solid white',
                }}
              >
                {header.charAt(0).toUpperCase() + header.slice(1)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {smartTableData.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              style={{
                backgroundColor: '#333',
                color: 'white',
              }}
            >
              {headers.map((header, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    fontSize: '12px',
                    padding: '12px',
                    textAlign: 'left',
                    backgroundColor: '#333',
                    borderTop: '1px solid white',
                    borderRight:
                      colIndex !== headers.length - 1 ? '1px solid white' : 'none', // No right border for the last column
                  }}
                >
                  {row[header]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export { SmartTable };
